import React from 'react';
import { Checkbox, InputLabel, ListItemText, MenuItem, OutlinedInput, Select } from '@mui/material';
import { FilterOption } from '../utils/filter-options';

type ChangeHandler = (e: any) => void;

// Campo de texto/número dos filtros: Enter dispara a consulta
export function FilterInput({ label, name, value, type, onChange, onSearch }: {
    label: string; name: string; value?: string | number; type?: 'text' | 'number'; onChange: ChangeHandler; onSearch: () => void;
}) {
    return (
        <React.Fragment>
            <InputLabel>{label}</InputLabel>
            <OutlinedInput
                fullWidth
                name={name}
                type={type}
                value={value ?? ''}
                onChange={onChange}
                onKeyDown={(e) => e.key === 'Enter' && onSearch()}
            />
        </React.Fragment>
    );
}

// Seleção dos filtros com a opção vazia ("Todos"/"Todas") no topo
export function FilterSelect({ label, name, value, options, emptyLabel = 'Todos', disabled, onChange }: {
    label: string; name: string; value?: string | number; options: FilterOption[]; emptyLabel?: string; disabled?: boolean; onChange: ChangeHandler;
}) {
    return (
        <React.Fragment>
            <InputLabel>{label}</InputLabel>
            <Select fullWidth name={name} value={value ?? ''} onChange={onChange} disabled={disabled}>
                <MenuItem value=""><em>{emptyLabel}</em></MenuItem>
                {options.map((o) => <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>)}
            </Select>
        </React.Fragment>
    );
}

// Seleção múltipla dos filtros (vazio = todos), com os rótulos escolhidos separados por vírgula
export function FilterMultiSelect({ label, name, value, options, emptyLabel = 'Todos', disabled, onChange }: {
    label: string; name: string; value: (string | number)[]; options: FilterOption[]; emptyLabel?: string; disabled?: boolean; onChange: ChangeHandler;
}) {
    return (
        <React.Fragment>
            <InputLabel>{label}</InputLabel>
            <Select
                fullWidth
                multiple
                displayEmpty
                name={name}
                value={value}
                onChange={onChange}
                disabled={disabled}
                renderValue={(selected) => (selected as (string | number)[]).length === 0
                    ? <em>{emptyLabel}</em>
                    : options.filter((o) => (selected as (string | number)[]).includes(o.value)).map((o) => o.label).join(', ')}
            >
                {options.map((o) => (
                    <MenuItem key={o.value} value={o.value}>
                        <Checkbox size="small" checked={value.includes(o.value)} sx={{ p: 0.5, mr: 1 }} />
                        <ListItemText primary={o.label} />
                    </MenuItem>
                ))}
            </Select>
        </React.Fragment>
    );
}
